import { PbxNumberPicker } from "./pbx_number_picker";

export class PbxEditExtension extends HTMLElement {
  constructor(group_id, domain_id, showList, reloadTable, data) {
    super();
    this.group_id = group_id;
    this.domain_id = domain_id;
    this.showList = showList;
    this.reloadTable = reloadTable;
    this.data = data;
  }
  async connectedCallback() {
    let users_req = await fetch(`/admin/groups/${this.group_id}/users`)
    let users = await users_req.json();
    users = users.data.filter((user)=>user.user_profile != null && user.user_profile.first_name != "" && user.user_profile.last_name != "").map((user)=> {
      return `<option value='${user.id}'>${user.user_profile.first_name} ${user.user_profile.last_name} (${user.email})</option>"`
    });
    this.innerHTML =
      `
      <style>
        pbx-edit-extension input,
        pbx-edit-extension select {
          margin-bottom: 20px;
        }

        .remove_extension_did {
          margin-left: 20px;
        }
      </style>
      <div class="row pbx_extension_form">
        <div class="col-sm-12 no-gutters">
          <h3><span id="pbx_extension_back"></span> Edit Extension</h3>
        </div>
        <div class="errors"></div>
        <div class="col-sm-7">
          <button class="btn btn-outline-danger delete_extension pull-right">Delete</button>
        </div>
        <div class="col-sm-7">
          <label>Assign to</label>
          <select class="form-control extension_names">
            <option value="null">Select</option>
            <option value="virtual">Add new virtual contact</option>
            ${users.join()}
          </select>
          <div class="extension_name_options hidden">
            <input class="form-control extension_new_name" placeholder="Name" value="${this.data.extension_name ?this.data.extension_name : '' }">
            <label>Call Treatment</label>
            <select is=treatments-select class="form-control call_treatments_id" data-cy="call-treat-id" domain_id="${this.domain_id}" data-selected="${this.data.target_id}"></select>
          </div>
        </div>
        <div class="col-sm-7">
          <label>Extension Number</label>
          <input class="form-control extension_number" value="${this.data.extension}">
        </div>
        <div class="extension_did_container">
          ${this.data.did ? `<div class="col-sm-7">
                              <label>Phone Number</label>
                              <br>
                              <span>${this.data.did.toString().replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}</span><button class="btn btn-outline-danger remove_extension_did">Remove</button>
                            </div>`
                            :
                            `<div class="col-sm-7">
                              <label>Select local or toll free number (Optional)</label>
                            </div>
                            <pbx-number-picker></pbx-number-picker>`}
        </div>
        ${this.data.user_id != null ? `
        <div class="col-sm-7">
          <p>
            user: ${this.data.user_id}.${this.data.auto_group_id}<br/>pbx password: ${this.data.api_token}
          </p>
        </div>` : ""}
        <div class="form-group col-sm-7 no-gutters" style="overflow:auto;">
          <button id="edit_extension_save" class='btn btn-primary pull-right detail-row-button'>Save</button>
          <button id="edit_extension_cancel" class='btn btn-outline-secondary pull-right detail-row-button'>Close</button>
        </div>
      </div>
      `;

    if(this.data.user_id) {
      this.querySelector('.extension_names').value = this.data.user_id;
    } else {
      this.querySelector('.extension_names').value = 'virtual';
      this.handleName('virtual');
    }

    this.querySelectorAll('#edit_extension_cancel, #pbx_extension_back').forEach(e => {
      e.addEventListener('click', function() {
        this.hide();
      }.bind(this))
    })

    this.querySelector('.extension_names').onchange = (e) => {this.handleName(e.target.value)}

    this.querySelector('#edit_extension_save').addEventListener('click', function() {
      this.save();
    }.bind(this))

    this.querySelector('.delete_extension').addEventListener('click', function() {
      this.deleteExtension();
    }.bind(this))

    if(this.data.did) {
      this.querySelector('.remove_extension_did').addEventListener('click', function() {
        this.deleteNumber();
      }.bind(this))
    }
  }

  hide(){
    this.showList();
    this.remove();
  }

  handleName(val) {
    if (val == "virtual") {
      this.querySelector('.extension_name_options').classList.remove('hidden');
    } else {
      this.querySelector('.extension_name_options').classList.add('hidden');

    }
  }

  validate() {
    let isValid = true;
    let errors = '';
    this.querySelector('.errors').innerHTML = '';
    this.querySelectorAll('.error').forEach(e => {
      e.classList.remove('error');
    })
    let validateNumber = this.querySelector('pbx-number-picker') ? this.querySelector('pbx-number-picker').validate() : {isValid:true};

    if(this.querySelector('.extension_names').value == 'null') {
      this.querySelector('.extension_names').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select an assignment option.
                                                </div>`;

      isValid = false;
    }
    if(this.querySelector('.extension_names').value == 'virtual' && !this.querySelector('.extension_new_name').value) {
      this.querySelector('.extension_new_name').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please provide an extension name.
                                                </div>`;

      isValid = false;
    }
    if(this.querySelector('.extension_names').value == 'virtual' && !this.querySelector('.call_treatments_id').value) {
      this.querySelector('.call_treatments_id').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a call treatment.
                                                </div>`;

      isValid = false;
    }
    if(!this.querySelector('.extension_number').value) {
      this.querySelector('.extension_number').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please provide an extension number.
                                                </div>`;

      isValid = false;
    }
    if(this.querySelector('.extension_number').value.length > 10) {
      this.querySelector('.extension_number').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Extension exceeds max length (10).
                                                </div>`;

      isValid = false;
    }
    if(isNaN(this.querySelector('.extension_number').value)) {
      this.querySelector('.extension_number').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Extension must consist only of numbers.
                                                </div>`;

      isValid = false;
    }

    if(!validateNumber.isValid) {
      if(validateNumber.type == 'toll-free') {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a toll free prefix.
                                                </div>`;
      } else if (validateNumber.type == 'local') {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a local number prefix.
                                                </div>`;
      }
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;
    return isValid
  }

  async save() {
    if(!this.validate()) {
      return
    }

    let virtual = this.querySelector('.extension_names').value == 'virtual';

    this.querySelectorAll('.btn').forEach(e => {
      e.disabled = true;
    })
    let data = {
      extension: this.querySelector('.extension_number').value
    }

    if(!virtual) {
      data.user_id = this.querySelector('.extension_names').value;
      data.target_id = null;
    }
    else {
      data.extension_name = this.querySelector('.extension_new_name').value;
      data.user_id = null;
      data.target_id = this.querySelector('.call_treatments_id').value;
    }

    data.campaign_name = (virtual) ? data.extension_name : "PBX_CAMPAIGN_DIRECT_LINE";

    if(this.querySelector('pbx-number-picker')) {
      let phone_number = this.querySelector('pbx-number-picker').getData()
      if(phone_number) {
        data.local_numbers = phone_number.local_numbers;
        data.npanxx = phone_number.npanxx;
      }
    }

    let res = await fetch(`/admin/groups/${this.group_id}/pbx/${this.data.id}/update_extension`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
      method: 'PUT',
      body: JSON.stringify(data)
    });
    let response = await res.json();
    if(response.success) {
      Common.notify('Extension updated', 'success');
      this.reloadTable();
      document.querySelector('pbx-numbers').reloadTable();
      this.hide();
    } else {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Unable to update extension. ${response.error ? response.error : ""}
                                                  </div>`
      this.querySelectorAll('.btn').forEach(e => {
        e.disabled = false;
      })
    }
  }

  async deleteNumber() {
    if(await confirmPlus("Are you sure you want to delete this number?")) {
      let res = await fetch(`/admin/groups/${this.group_id}/pbx/${this.data.id}/delete_extension_number`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'DELETE'
      })
  
      let response = await res.json();
      if(response.success) {
        Common.notify('Phone number deleted', 'success');
        this.reloadTable();
        document.querySelector('pbx-numbers').reloadTable();
        this.querySelector('.extension_did_container').innerHTML = `<div class="col-sm-7">
                                                                      <label>Select local or toll free number (Optional)</label>
                                                                    </div>
                                                                    <pbx-number-picker></pbx-number-picker>`
      } else {
        this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Unable to delete phone number.
                                                  </div>`
      }
    }
  }

  async deleteExtension() {
    if(await confirmPlus("Are you sure you want to delete this extension?")) {
      let res = await fetch(`/admin/groups/${this.group_id}/pbx/${this.data.id}/delete_extension`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'DELETE',
      })
  
      let response = await res.json();
      if(response.success) {
        Common.notify('Extension deleted', 'success');
        this.reloadTable();
        document.querySelector('pbx-numbers').reloadTable();
        this.hide();
      } else {
        this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Unable to delete extension.
                                                  </div>`
      }
    }
  }
}

customElements.define('pbx-edit-extension', PbxEditExtension)